<div class="mt-page">
  <h2 class="mt-title">My open tasks</h2>

  <div *ngIf="!loading && !tasks.length" class="mt-empty">
    <mat-icon>checklist</mat-icon>
    <p>No open tasks assigned to you.</p>
  </div>

  <div
    *ngFor="let t of tasks"
    class="mt-card"
    [class.mt-card--overdue]="isOverdue(t)"
    [class.mt-card--today]="isDueToday(t)"
  >
    <div class="mt-card-main" (click)="openCustomer(t)">
      <div class="mt-card-title">{{ t.title }}</div>
      <div class="mt-card-sub">
        Due {{ toMillis(t.dueDate) | date:'mediumDate' }}
        <span *ngIf="isOverdue(t)" class="mt-badge mt-badge--overdue">Overdue</span>
        <span *ngIf="isDueToday(t)" class="mt-badge mt-badge--today">Due today</span>
      </div>
    </div>
    <button mat-icon-button color="primary" aria-label="Mark complete" (click)="completeTask(t)">
      <mat-icon>check_circle</mat-icon>
    </button>
  </div>
</div>
